(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("selfRegistration", {
        templateUrl: "app/public/selfRegistration.component.html",
        controller: ["publicResource", "organizationsFilterResource", "calendarSettingsService", "globalizationService", "messageService", "frameworkService", "$timeout", "$scope", "$state", "$q", "$translate", "_", "REG_EXP", "SELFREGISTRATION_SETTINGS", SelfRegistrationCtrl],
        controllerAs: "vm"
    });
    function SelfRegistrationCtrl(publicResource, organizationsFilterResource, calendarSettingsService, globalizationService, messageService, frameworkService, $timeout, $scope, $state, $q, $translate, _, REG_EXP, SELFREGISTRATION_SETTINGS) {
        var vm = this;
        vm.data = frameworkService.data;
        vm.selfRegistrationSettings = {
            selfRegistrationEnabled: frameworkService.data.tenant.active,
            billingInformation: 0
        };
        vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
        vm.selectedLanguage = frameworkService.data.selectedLanguage;
        vm.model = {
            organization: "",
            organizationName: "",
            organizationId: null,
            billingAddress: {
                countryId: "",
                stateProvinceId: ""
            },
            localizationId: vm.selectedLanguage.id
        };
        vm.passwordPattern = REG_EXP.password;
        vm.emailPattern = REG_EXP.email;
        vm.userNamePattern = REG_EXP.username;
        vm.phonePattern = REG_EXP.phone;
        vm.loading = true;
        vm.saving = false;
        vm.showErrors = false;
        vm.isSpecialCharacter = false;
        vm.isExternalUser = false;
        //Organizations
        vm.showOrganizationFieldset = vm.data.tenantFeatures.organization
            && (vm.data.tenant.tenantFeaturesSelfRegistrationOrgSignUpCodeEnabled
                || vm.data.tenant.tenantFeaturesOrganizationDropdown);
        vm.showSignupCodeNote = vm.data.tenantFeatures.organization && vm.data.tenant.tenantFeaturesSelfRegistrationOrgSignUpCodeEnabled && !vm.data.tenant.tenantFeaturesOrganizationDropdown;
        vm.showSignupCodeDropdownNote = vm.data.tenantFeatures.organization && vm.data.tenant.tenantFeaturesSelfRegistrationOrgSignUpCodeEnabled && vm.data.tenant.tenantFeaturesOrganizationDropdown;
        vm.showAddOrganizationNote = vm.data.tenantFeatures.organization && vm.data.tenant.tenantFeaturesUserCanAddOrganization && vm.data.tenant.tenantFeaturesOrganizationDropdown;
        vm.showOtherOrganization = false;
        vm.showOrganizationNote = vm.showSignupCodeNote || vm.showAddOrganizationNote || vm.showSignupCodeDropdownNote;
        vm.orgSearch = "";
        vm.organizations = [];
        //Date picker config
        vm.format = "yyyy-MM-dd";
        calendarSettingsService.calendarSetup($scope);
        vm.open = calendarSettingsService.open;
        //Future Date Validation
        vm.checkDate = calendarSettingsService.checkDate;
        if ($state.params.organization) {
            //if (!vm.data.tenantFeatures.organization || !vm.data.tenant.tenantFeaturesOrganizationURL) {
            //	$state.go('main.notFound');
            //	return;
            //}
            publicResource.getOrganizationByUrlCode({ actionValue: $state.params.organization }, function (result) {
                if (!result.id)
                    return;
                vm.organizationUrlCode = $state.params.organization;
                vm.organizationName = result.name;
                vm.model.organizationId = result.id;
                vm.showOrganizationFieldset = true;
                vm.showOrganizationNote = false;
            }, function () {
                messageService.error("common.genericError");
            });
        }
        loadData();
        function loadData() {
            publicResource.getSelfRegistrationSettings(function (result) {
                vm.selfRegistrationSettings = result;
                vm.selfRegistrationSettings.selfRegistrationEnabled = vm.selfRegistrationSettings.selfRegistrationEnabled && frameworkService.data.tenant.active;
                angular.extend(vm.model, result.externalUser);
                vm.model.registrationToken = result.registrationToken;
                if (vm.model.organizationName == null)
                    vm.model.organizationName = "";
                vm.isExternalUser = result.externalUser !== null;
                $timeout(function () {
                    vm.loading = false;
                });
            });
        }
        ;
        //Check if password has special characters that are not allowed
        vm.checkSpecialCharacter = function (password) {
            if (password)
                return REG_EXP.specialCharacterPassword.test(password);
            return false;
        };
        vm.checkSignupCode = function (code) {
            return $q(function (resolve, reject) {
                if (typeof (code) === 'undefined' || code === '') {
                    resolve(true);
                }
                else {
                    publicResource.isSignupCodeValid({ actionValue: code }, function (result) {
                        if (result.value)
                            resolve(true);
                        else
                            reject();
                    }, function () {
                        messageService.error("common.genericError");
                    });
                }
                ;
            });
        };
        vm.loadStateProvince = function (countryId) {
            if (!countryId)
                return;
            var countryObj = _.find(vm.selfRegistrationSettings.enabledCountries, { id: countryId });
            globalizationService.load(countryObj.threeLetterISOCode, function (result) {
                vm.stateProvinceLabel = result.stateProvinceLabel;
                vm.postalZipLabel = result.postalZipLabel;
                vm.postalZipRegex = new RegExp(result.postalZipRegex);
                vm.postalZipPattern = result.postalZipPattern;
            });
            vm.selfRegistrationSettings.stateProvinces = countryObj.stateProvinces;
        };
        vm.checkUsernameIsAvailable = function (username) {
            return $q(function (resolve, reject) {
                publicResource.isUsernameAvailable({ actionValue: username }, function (result) {
                    if (result.value)
                        resolve(true);
                    else
                        reject();
                }, function () {
                    messageService.error("common.genericError");
                });
            });
        };
        //checks if user name is formatted like email and places in email input
        vm.userNameEmail = function () {
            if (vm.model.userName) {
                if (vm.model.userName.match(vm.emailPattern))
                    vm.model.email = vm.model.userName;
            }
        };
        vm.refreshOrganizations = function (val) {
            vm.orgSearch = val;
            organizationsFilterResource.getCachedEnabled({ name: val }, function (result) {
                vm.organizations = result;
                if (vm.data.tenantFeatures.organization && vm.data.tenant.tenantFeaturesUserCanAddOrganization) {
                    vm.organizations.push({ name: $translate.instant('public.selfRegistration.addOrganization'), id: -1 });
                }
            });
        };
        vm.refreshOrganizations("");
        vm.onSelect = function (item) {
            vm.model.organizationName = vm.orgSearch;
            vm.model.organization = item;
            vm.model.organizationId = item.id;
            vm.showOtherOrganization = item.id == -1;
        };
        vm.organizationChanged = function () {
            vm.model.organizationId = null;
            vm.model.organizationName = "";
        };
        vm.signupCodeChanged = function () {
            vm.model.organizationId = null;
            vm.model.organizationName = "";
            vm.organizationName = "";
            if (vm.model.signupCode) {
                publicResource.getOrganizationNameBySignupCode({
                    actionValue: vm.model.signupCode
                }, function (result) {
                    vm.organizationName = result.value;
                }, function () {
                    messageService.error("common.genericError");
                });
            }
        };
        vm.save = function () {
            if (vm.saving)
                return;
            vm.saving = true;
            $timeout(function () {
                if (vm.form.$valid) {
                    vm.model.localizationId = vm.selectedLanguage.id;
                    vm.model.code = $state.params.code;
                    vm.model.organizationSignUpUrl = $state.params.organization;
                    if (vm.selfRegistrationSettings.gender === SELFREGISTRATION_SETTINGS.required && !vm.model.gender) {
                        vm.genderRequired = true;
                        vm.showErrors = true;
                        vm.saving = false;
                        return;
                    }
                    if (vm.model.organizationId < 0) {
                        vm.model.organizationId = null;
                    }
                    publicResource.saveSelfRegistration(vm.model, function () {
                        messageService.success("public.selfRegistration.success");
                        $state.go("main.signIn");
                    }, function (error) {
                        if (error.status = 429) {
                            messageService.error(error, { duration: 1 });
                            loadData();
                        }
                        else {
                            messageService.error(error);
                        }
                        vm.saving = false;
                    });
                }
                else {
                    vm.saving = false;
                    vm.showErrors = true;
                }
            }, 210);
        };
    }
}());
